const Backbone = require('backbone');
const BundleModel = require('app/models/store/client/product/bundle');
const dustjs = require('dustjs');
const bundleDust = require('store/global/pages/products/_bundle.dust');
require('store/global/pages/products/_bundled_product_tile.dust');

module.exports = Backbone.View.extend({
	el: '.bundle',
	initialize: function(options) {
		if (options && options.finishesView) {
			this.listenTo(options.finishesView.collection, 'finishSelected', this._handleFinishChange.bind(this));
		}
		this.bundleModels = {};
	},
	render: function(finishUniqueId, price) {
		var bundleModel = this.bundleModels[finishUniqueId];

		if (bundleModel) {
			this._dustRender.call(this, bundleModel);
		} else {
			this._fetchAndRender.call(this, finishUniqueId, price);
		}
	},
	_fetchAndRender: function(finishUniqueId, price) {
		var newBundleModel = new BundleModel({
			productUniqueId: finishUniqueId,
			originalProductPrice: price
		});
		newBundleModel.fetch({
			success: this._dustRender.bind(this)
		});
	},
	_dustRender: function(bundleModel) {
		this.bundleModels[bundleModel.attributes.productUniqueId] = bundleModel;
		dustjs.render(bundleDust, { bundle: bundleModel.attributes }, this._handleDustRenderResult.bind(this));
	},
	_handleFinishChange: function(finish) {
		this.render.call(this, finish.uniqueId, finish.price);
	},
	_handleDustRenderResult: function(error, result) {
		if (!error) {
			this.$el.find('.bundled-products').replaceWith(result);
		}
	}
});
